import LookupChooseFile from '@/Components/LookupChooseFile/LookupChooseFile';
import { Button } from '@/Components/UI/Button/Button';
import Modal from '@/Components/UI/Modal/Modal';

const FilterFilePickerModal = ({ show, hideModal, setSelectedFile }) => {
  const onCloseModal = () => {
    hideModal();
  };

  return (
    <Modal
      size='large'
      isOpen={show}
      onClose={onCloseModal}
      title='Select File for Filter'
      iconName='file-search'
    >
      <LookupChooseFile setSelectedFile={setSelectedFile} closeModal={onCloseModal} />
      <hr className='mb-5 solid' />
      <div className='flex justify-end gap-4'>
        <Button variant='ghost' onClick={onCloseModal}>
          Cancel
        </Button>
      </div>
    </Modal>
  );
};

export default FilterFilePickerModal;
